import produce from 'immer';
import { createReducer } from 'typesafe-actions';
import * as Actions from '../actions/mainDashAction';
import { initMainDash, MainDashState } from '../models/mainDashModel';

export const mainDahReducer = createReducer<
  MainDashState,
  Actions.MainDashAction
>(initMainDash)
  .handleAction(Actions.STCS_DAY.success, (state, action) =>
    produce(state, draft => {
      const { data } = action.payload;
      draft.stcsDayList = data;
    })
  )
  .handleAction(Actions.STCS_AREA.success, (state, action) =>
    produce(state, draft => {
      const { data } = action.payload;
      draft.stcsAreaList = data;
    })
  )
  .handleAction(Actions.GROUP_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data } = action.payload;
      draft.groupList = data;
    })
  )

  .handleAction(Actions.DRON_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data } = action.payload;
      draft.dronList = data;
    })
  );
